import styles from './styles.module.scss';

import icon from './icon.png';
import { ModuleProps } from '../config/ModulesList';
import { DragItems, Codes, Answer } from '../../types';
import { VarTypes, CodeWithBox } from '../layouts';
import { Board } from '../../components/Board';
import { DragBox } from '../../components/DragBox';
import { ExTracker } from '../../components/ExTracker';
import moment from 'moment';
import { DropBox } from '../../components/DropBox';
import { Loading } from '../../components/Loading';
import { isArrayEmpty } from '../../globalFunctions';
import { ComputerAndTrash } from '../../components/ComputerAndTrash';
import { Pseudocode } from '../../components/Pseudocode';
import { CodeWithMatrix } from '../../components/CodeWithMatrix';
import { MatrixBox, MatrixBoxProps } from '../../components/MatrixBox';
import CustomText from '../../components/CustomText';
import { YoutubeVideo } from '../../components/YoutubeVideo';
export const ICON = icon;

type DropItems = {
    id: number;
    name: string;
    type: 'checkBox' | 'varType' | 'code' | 'trash' | string;
    text?: string;
    code?: string[];
    multiple?: boolean;
    correct?: boolean;
    textLeft?: string;
    textRight?: string;
    css?: any;
};

type Steps = {
    id: number;
    text: string;
    dropAreas: string[];
    imagem: string;
    width: number;
    height: number;
    css?: any;
};

type EX = {
    image: string;
    codes?: Codes[];
    dropAreas: DropItems[];
    steps: Steps[];
    layout?: string[][];
    pseudocode?: any;
    matrix?: any;
};

export const Tutorial = ({
    currentEx,
    maxEx,
    currentExJson,
    setEndTime,
    setHits,
    setMisses,
    checkIfIsFinished,
    checkAnswers,
    isReloadingContent,
    sortFeedback,
    acessivel
}: ModuleProps<EX>) => {
    const multipleItemsDropBoxExs = [1, 2, 3, 4];
    let previousAnswers = sessionStorage.getItem('previousAnswers');
    let answers: Answer[] = previousAnswers
        ? JSON.parse(previousAnswers)
        : Array(currentExJson.steps.length);
    // Each time a dragBox is dropped
    const validateOnDrop = (dragBox: DragItems, dropBox: DropItems) => {
        let valid = false;
        dragBox.validDrops.forEach(item => {
            if (item === dropBox.name) {
                valid = true;
            }
        });

        answers[dragBox.id] = {
            dragBox: {
                dragBoxId: dragBox.id,
                dragBoxValidDrops: dragBox.validDrops
            },
            dropBox: {
                id: dropBox.id,
                name: dropBox.name,
                type: dropBox.type
            },
            isInCorrectDropBox: valid
        };

        sessionStorage.setItem('previousAnswers', JSON.stringify(answers));

        if (checkIfIsFinished(answers)) {
            if (checkAnswers(false, answers) == 0) {
                sortFeedback('CORRECT');
            } else {
                sortFeedback('INCORRECT');
            }
            setEndTime(moment().format('HH:mm:ss'));
            setHits(checkAnswers(true, answers));
            setMisses(checkAnswers(false, answers));
            sessionStorage.setItem('previousAnswers', JSON.stringify(answers));
        }
    };

    const renderDropBoxFromCorrect = (item: DropItems) => {
        const key = parseInt(currentEx.toString() + item.id.toString());

        return (
            <DropBox
                key={key}
                className={`${styles.box} ${styles.boxDrop}`}
                items={
                    {
                        id: item.id,
                        name: item.name,
                        type: item.type
                    } as DropItems
                }
                onDrop={validateOnDrop}
                multiple={true}
            >
                <div className={`${styles.dropInner}`}>Coloque as opções corretas aqui</div>
            </DropBox>
        );
    };

    const renderDropBoxFromIncorrect = (item: DropItems) => {
        const key = parseInt(currentEx.toString() + item.id.toString());

        return (
            <DropBox
                key={key}
                className={`${styles.box} ${styles.boxDrop}`}
                items={
                    {
                        id: item.id,
                        name: item.name,
                        type: item.type
                    } as DropItems
                }
                onDrop={validateOnDrop}
                multiple={true}
            >
                <div className={`${styles.dropInner}`}>Coloque as opções incorretas aqui</div>
            </DropBox>
        );
    };

    const renderDropBoxFromPseudocode = (item: Codes) => {
        const key = parseInt(currentEx.toString() + item.id.toString());

        return (
            <Pseudocode
                key={key}
                code={item.code ? item.code : []}
                dropAreas={currentExJson.dropAreas ? currentExJson.dropAreas : []}
                validateOnDrop={validateOnDrop}
                currentEx={currentEx}
            />
        );
    };

    const renderDropBox = (dropArea: any) => {
        const key = parseInt(currentEx.toString() + dropArea.id.toString());
        switch (dropArea.type) {
            case 'trash':
                return (
                    <ComputerAndTrash
                        type={dropArea.type}
                        name={dropArea.name}
                        id={dropArea.id}
                        component={'trash'}
                        validateOnDrop={validateOnDrop}
                        scale={1}
                        size={{x: dropArea.width * window.innerWidth,y: dropArea.height * window.innerHeight}}
                        dropArea={dropArea}
                        css={dropArea.css}
                        pos={{
                            x: dropArea.pos.x,
                            y: dropArea.pos.y
                        }}
                    />
                );
            case 'dropBox':
                return (
                    <DropBox
                        key={key}
                        className={`${styles.box} ${styles.boxDrop}`}
                        items={{ id: dropArea.id, name: dropArea.name } as DropItems}
                        onDrop={validateOnDrop}
                        css={dropArea.css}
                        dropArea={dropArea}
                        multiple={dropArea.multiplo}
                    >
                        <div className={styles.dropInner}>{dropArea.text}</div>
                    </DropBox>
                );
            case 'texto':
                return (
                    <CustomText
                        texto={dropArea.text}
                        id={dropArea.id}
                        css={dropArea.css}
                        isLogicMaker={false}
                        onClick={validateOnDrop}
                        size={{
                            x: dropArea.width * window.innerWidth,
                            y: dropArea.height * window.innerHeight
                        }}
                        pos={dropArea.pos}
                    />
                );

            case 'video':
                return (
                    <YoutubeVideo
                        size={{ x: dropArea.width, y: dropArea.height }}
                        pos={dropArea.pos}
                        id={key.toString()}
                        videoUrl={dropArea.url}
                    />
                );
            case 'imagem':
                return (
                    <img
                        src={dropArea.imagem}
                        alt={dropArea.text}
                        style={{
                            height: dropArea.height * window.innerHeight,
                            width: dropArea.width * window.innerWidth,
                            margin: 0,
                            left: dropArea.pos.x * window.innerWidth,
                            top: dropArea.pos.y * window.innerHeight,
                            position: 'fixed',
                            ...dropArea.css
                        }}
                        draggable={false}
                    />
                );
            default:
                return <></>;
        }
    };

    const renderDragBox = (item: Steps) => {
        const key = parseInt(currentEx.toString() + item.id.toString());
        return (
            <DragBox
                style={{ ...item.css, backgroundImage: acessivel ? item.css.backgroundImage : `url(${item.imagem})`,backgroundSize: '100% 100%',width: item.width * window.innerWidth,height: item.height * window.innerHeight }}
                key={key}
                className={`${styles.box} ${styles.boxDrag} ${styles.boxDragLevel} dragBoxItem`}
                hideOnDrag={true}
                items={
                    {
                        id: item.id,
                        validDrops: item.dropAreas
                    } as DragItems
                }
            >
                {acessivel ? '' : <div>{item.text}</div>}
            </DragBox>
        );
    };

    const renderTemplateBoxes = () => {
        let content: JSX.Element[] = [];

        if (currentExJson.codes) {
            currentExJson.codes.forEach(code => {
                content.push(renderDropBoxFromPseudocode(code));
            });
        }

        if (currentExJson.layout) {
            content.push(
                <MatrixBox
                    layout={currentExJson.layout}
                    dropAreas={currentExJson.dropAreas ? currentExJson.dropAreas : []}
                    validateOnDrop={validateOnDrop}
                    currentEx={currentEx}
                    show={currentEx != 1}
                />
            );
        }

        if (currentExJson.pseudocode && currentExJson.matrix) {
            content.push(
                <CodeWithMatrix
                    className={styles.longArray}
                    pseudocode={currentExJson.pseudocode}
                    matrix={currentExJson.matrix}
                    validateOnDrop={validateOnDrop}
                    currentEx={currentEx}
                    show={true}
                />
            );
        }

        if (currentExJson.dropAreas) {
            console.log(currentExJson.dropAreas);
            currentExJson.dropAreas.forEach(dropArea => {
                var correto: Steps | undefined = undefined;
                answers.forEach((answer: Answer, index) => {
                    if (answer && answer.dropBox.id == dropArea.id && answer.isInCorrectDropBox) {
                        currentExJson.steps.forEach((item: Steps) => {
                            if (answer.dragBox.dragBoxId === item.id && dropArea.type != "trash") {
                                correto = item;
                                dropArea.text = item.text;
                                dropArea.css = item.css;
                            }
                        });
                    }
                });
                correto
                    ? content.push(renderDropBox(dropArea))
                    : content.push(renderDropBox(dropArea));
            });
        }
        return <>{content}</>;
    };

    const renderResponseBoxes = () => {
        let content: any[] = [];

        if (!isArrayEmpty(answers)) {
            currentExJson.steps.forEach((item: Steps) => {
                let found = false;

                answers.forEach((answer: Answer) => {
                    if (answer?.dragBox.dragBoxId === item.id) {
                        found = true;

                        if (!answer.isInCorrectDropBox) {
                            content.push(renderDragBox(item));
                        }
                    }
                });

                if (!found) {
                    content.push(renderDragBox(item));
                }
            });
        } else {
            // **aqui**: quando não há nenhuma resposta, ele também exibe todos como DragBox
            currentExJson.steps.forEach(step => {
                content.push(renderDragBox(step));
            });
        }

        return <>{content}</>;
    };

    return (
        <div className={styles.wrapper}>
            <Board wrapperClass={styles.board}>
                <div className={styles.boardInner}>
                    {isReloadingContent ? (
                        <Loading />
                    ) : (
                        <>
                            <div className={styles.exTrackerWrapper}>
                                <ExTracker
                                    className={styles.exTracker}
                                    currentEx={currentEx}
                                    maxEx={maxEx}
                                />
                            </div>
                            <div className={`${styles.main} ${styles.mainLeft}`}>
                                {renderTemplateBoxes()}
                            </div>
                            <div className={`${styles.main} ${styles.mainRight} dragBoxContainer`}>
                                {renderResponseBoxes()}
                            </div>
                        </>
                    )}
                </div>
            </Board>
        </div>
    );
};
